import { render, staticRenderFns } from "./ReturnGoodsCreationSection.vue?vue&type=template&id=8c64bbb6"
import script from "./ReturnGoodsCreationSection.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsCreationSection.vue?vue&type=script&lang=js"
import style0 from "./ReturnGoodsCreationSection.vue?vue&type=style&index=0&id=8c64bbb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports